module.exports = __webpack_public_path__ + "img/ecobee.4059ca85.png";